import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/marketing/AffiliateSourceCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangFromParams"] */ "/vercel/path0/src/components/seo/LangFromParams.tsx");
